export default window ? window.document : undefined;